import React from "react";
import {Select} from "./Select";
import {SelectId} from "./SelectId";

const types = [
    { id: 'NONE', label: 'Not received' },
    { id: 'PARTIAL', label: 'Partially received' },
    { id: 'FULL', label: 'Received' }
];
export const PostersReceivedSelect = (props)=> {
    console.log('PR5',props);
    return props.valueIsId?<SelectId {...props} options={types} labelField="label"/>:<Select {...props} options={types} labelField="label"/>;
}